import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { pageMeta } from "@/lib/seo/meta";
import { TOOL_CACHE_HEADERS } from "@/lib/seo/headers";

const ImageToPdfView = lazy(() => import("@/features/image-to-pdf/view"));

export const Route = createFileRoute("/image-to-pdf")({
  head: () =>
    pageMeta({
      title: "Image to PDF",
      description:
        "Drop in JPGs, PNGs, or WebPs and get one tidy PDF back. Reorder before you download.",
      path: "/image-to-pdf",
      keywords: "image to pdf, jpg to pdf, png to pdf, photo to pdf, online, free",
    }),
  headers: () => TOOL_CACHE_HEADERS,
  component: () => (
    <Suspense fallback={null}>
      <ImageToPdfView />
    </Suspense>
  ),
});
